module.exports = __webpack_public_path__ + "img/amb_bg1.2d15cf21.png";